import {Record as record} from 'immutable';

import trainTime from '../../lib/TrainTime';
import {SmartCarnetFiltersService, SmartCarnetFiltersRoute, SmartCarnetFilterTypes, SmartCarnetTicketCodes} from '../../constants/AppConstants';

const defaults = {
    route: [SmartCarnetFiltersRoute.ANY_PERMITTED, SmartCarnetFiltersRoute.BRAND_ONLY],
    service: [SmartCarnetFiltersService.OFF_PEAK, SmartCarnetFiltersService.PEAK]
};

const filterOffPeak = fares => fares.filter(fare => fare.ticketType.code !== SmartCarnetTicketCodes.OFF_PEAK);
const filterPeak = fares => fares.filter(fare => fare.ticketType.code !== SmartCarnetTicketCodes.PEAK);
const filterDates = fares => fares.filter(fare =>
    fare.outwardValidity.from.isBefore(
        trainTime().endOf('day').add(1, 'month') // Filter out outside a time window
    )
);

class SmartCarnetRecordFilters extends record(defaults) {
    static fromJSON(json = {}) {
        return new SmartCarnetRecordFilters({
            route: json.route,
            service: json.service
        });
    }

    getAllSelected() {
        return [...this.route.filter(Boolean), ...this.service.filter(Boolean)];
    }

    getCount() {
        return this.getAllSelected().length;
    }

    getFilteredFares(fares) {
        let result = fares;

        if (!this.isSelected(SmartCarnetFilterTypes.SERVICE, SmartCarnetFiltersService.OFF_PEAK)) {
            result = filterOffPeak(result);
        }

        if (!this.isSelected(SmartCarnetFilterTypes.SERVICE, SmartCarnetFiltersService.PEAK)) {
            result = filterPeak(result);
        }

        result = filterDates(result);

        return result;
    }

    isLastActiveFilter(type) {
        return this[type].length === 1;
    }

    isSelected(type, value) {
        return this[type].includes(value);
    }

    updateFilter(type, value) {
        if (this[type].includes(value)) {
            if (!this.isLastActiveFilter(type)) {
                return this.set(type, this[type].filter(v => v !== value));
            } else {
                // Do not remove the filter as it's the last remaining one in the group
                return this;
            }
        } else {
            return this.set(type, [...this[type], value]);
        }
    }

}

export default SmartCarnetRecordFilters;



// WEBPACK FOOTER //
// ./src/records/smartCarnet/SmartCarnetRecordFilters.js